import { StaticQuery, graphql } from "gatsby"
import CustomLink from "../Link"
import React, { useEffect } from "react"
import styled from "@emotion/styled"

import Dropdown from "./dropdown"
import "./navigation.scss"

const Navigation = props => {
  const { data } = props

  const Nav = styled.nav`
    ${props.active_navigation !== "true"
      ? "background: linear-gradient(180deg, #000000 0, rgba(0, 0, 0, 0) 100%)"
      : "background: #000;"}
  `

  useEffect(() => {
    ActiveNavigation()

    window.addEventListener("scroll", ActiveNavigation)

    return () => {
      window.removeEventListener("scroll", ActiveNavigation)
    }
  })

  const ActiveNavigation = () => {
    const navigation = document.querySelector(".navigation")

    if (
      document.body.scrollTop > 80 ||
      document.documentElement.scrollTop > 80
    ) {
      navigation.style.background = "#000"
      navigation.style.transform = "translateY(-78px)"
    } else {
      if (props.active_navigation !== "true") {
        navigation.style.background =
          "linear-gradient(180deg, #000000 0%, rgba(0,0,0,0) 100%)"
      }
      navigation.style.transform = "translateY(0)"
    }
  }

  return (
    <Nav className="navigation">
      <div className="container">
        <CustomLink url="/" className="navigation__logo-link">
          <div className="navigation__logo">
            <img
              src={data.contentstackDraftkingsLogos.draftkings_stacked_logo.url}
              alt="Brand Logo"
            />
          </div>
        </CustomLink>
        <ul className="navigation__list">
          {data.contentstackMenu.menu_items.map(menuItem => {
            if (menuItem.url.href !== "") {
              return (
                <li className="navigation__label" key={menuItem.url.title}>
                  <CustomLink
                    activeClassName="active"
                    className="navigation__link"
                    url={menuItem.url.href}
                  >
                    {menuItem.url.title}
                  </CustomLink>
                </li>
              )
            } else {
              return <Dropdown menuItem={menuItem} key={menuItem.url.title} />
            }
          })}
          <li className="navigation__label navigation__label--sign-up">
            <a
              href={data.contentstackMenu.sign_up_desktop_link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="navigation__link"
            >
              {data.contentstackMenu.sign_up_desktop_link.title}
            </a>
          </li>
        </ul>
      </div>
    </Nav>
  )
}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        contentstackMenu {
          menu_items {
            url {
              title
              href
            }
            submenu {
              url {
                title
                href
              }
            }
          }
          sign_up_desktop_link {
            title
            href
          }
          sign_up_mobile_link {
            title
            href
          }
        }
        contentstackDraftkingsLogos {
          draftkings_stacked_logo {
            url
          }
        }
      }
    `}
    render={data => <Navigation data={data} {...props} />}
  />
)
